<template>
  <a-layout-header>
    <div class="nav-container">
      <a-menu
        theme="dark"
        mode="horizontal"
        :default-selected-keys="['2']"
        :style="{ lineHeight: '64px' }"
      >
        <a-menu-item key="1">
          nav 1
        </a-menu-item>
        <a-menu-item key="2">
          nav 2
        </a-menu-item>
        <a-menu-item key="3">
          nav 3
        </a-menu-item>
      </a-menu>
    </div>
  </a-layout-header>
</template>

<script>
// @ is an alias to /src

export default {
  name: "mainnavbar",
  components: {}
};
</script>

<style lang="scss"></style>
